import { DEVICE_TYPES } from "../../features/devices/constants";
import { Device } from "../../features/devices/models/device.model";
import { DeviceFeatures } from "../../features/devices/models/deviceFeatures.model";

export const isGateway = (device: Device): boolean =>
    device.deviceType === DEVICE_TYPES.GATEWAY;

export const isExternal = (device: Device): boolean => device.external === true;

export const isExternalGateway = (device: Device): boolean =>
    isGateway(device) && isExternal(device);

export const isFeatureDefined = (
    device: Device,
    featureName: keyof DeviceFeatures
): boolean => {
    const feature = device.features?.[featureName];
    return feature !== undefined && feature !== false;
};
